import React, { Component } from "react";
import { Field, reduxForm, Form, FieldProps } from "redux-form";
import { connect } from "react-redux";
import { Button, Glyphicon } from "react-bootstrap";
import "./styles.css";
import validate from "./validate";
import asyncValidate from "../../YourSummaryPanel/form/asyncValidate";
import {
  postBasketData,
  fetchBasketData,
  proceedStep
} from "../../../../actions/basket";

type Props = {
  handleSubmit: Function,
  onSubmit: Function,
  pristine: FieldProps,
  submitting: FieldProps,
  onSubmit: FieldProps,
  previousPage: Function
};

class WizardFormThirdPage extends Component<Props> {
  props: Props;

  render() {
    const handleClick = () => {
      this.props.onSelect();

      window.history.replaceState(
        null,
        "Airport Transfers to Ski Resorts | Ski-Lifts",
        "/quote/confirm/stp3/"
      );
      this.props
        .postBasketData(null, null, null, true, true)
        .then(response => {
          if (response.result === "error") {
            throw Error(response.message);
          }
          this.props.fetchBasketData(localStorage.getItem("guid"));
          this.props.proceedStep(this.props.basketId, "confirm").then(res => {
            if (res.hasFailed) {
              throw res.data.continueText;
            }
          });
        })
        .catch(() => console.error("error saving cart please contact Admin"));
    };
    return (
      <Form
        onSubmit={this.props.handleSubmit(this.props.onSubmit)}
        className="wizard-fourth-page"
      >
        <div>
          <label>Notes / Special Requirements</label>
          <div>
            <Field
              name="notes"
              component="textarea"
              placeholder="Notes"
              className="notes"
              onFocus={() => this.props.handleBlur("notes")}
            />
          </div>
        </div>
        <div className="next-button">
          {this.props.form === "transferDetailsOutboundForm" &&
          this.props.isThereAnInboundForm ? (
            <Button
              bsSize="large"
              bsStyle="success"
              type="submit"
              disabled={this.props.submitting}
              className="next"
              onFocus={() => this.props.handleBlur("")}
            >
            <span>ADD RETURN</span>
            </Button>
          ) : (
            <Button
              bsSize="large"
              bsStyle="success"
              onClick={handleClick}
              className="next"
            >
             <span>Next</span>
            </Button>
          )}
          <Button
            bsStyle="link"
            type="button"
            className="previous"
            onClick={this.props.previousPage}
          >
            <Glyphicon glyph="arrow-left" /> See previous screen
          </Button>
        </div>
      </Form>
    );
  }
}
WizardFormThirdPage = reduxForm({
  onSubmit: () => val => console.log(val),
  enableReinitialize: false,
  keepDirtyOnReinitialize: false,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate,
  asyncValidate
})(WizardFormThirdPage);
export default connect(null, { postBasketData, fetchBasketData, proceedStep })(
  WizardFormThirdPage
);



// WEBPACK FOOTER //
// ./src/containers/QuotePage/TravelDetailsPanel/form/WizardFormFourthPage.js